export const TOGGLE_THEME = 'TOGGLE_THEME';
